import { useQuery } from '@tanstack/react-query';
import { getValueCompliance, getComplianceDeadlines } from '../value.api';

export function useCompliance(gln: string) {
  return useQuery({
    queryKey: ['value', 'compliance', gln],
    queryFn: () => getValueCompliance(gln),
    enabled: !!gln,
    staleTime: 5 * 60 * 1000,
  });
}

export function useComplianceDeadlines(gln: string) {
  return useQuery({
    queryKey: ['value', 'compliance-deadlines', gln],
    queryFn: () => getComplianceDeadlines(gln),
    enabled: !!gln,
    staleTime: 5 * 60 * 1000,
  });
}
